export default __webpack_public_path__ + "static/media/herbalife1.f6e44483.mp4";